















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ExporoTooltip from '@/components/common/Tooltip.vue';

@Component({
  name: 'app-header',
  components: {
    ExporoTooltip,
  },
})
export default class AppHeader extends Vue {
  @Prop({ default: 0, required: true }) balance: string;
  @Prop({ default: false, required: false }) isCheckout: boolean;
  @Prop({ default: false, required: false }) hideWallet: boolean;

  get emoneyURL() {
    return process.env.VUE_APP_EXPORO_WALLET_URL;
  }
}
